import React from 'react'
import './index.css'

export default function Index() {
  return (
    <div className="loader-wrapper">
          <span className="loader">
            <span className="loader-inner"></span>
          </span>
        </div>
  )
}
